import React from 'react';
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';
import Home from './home/Home';
import LogInSplashScreen from './LogInSplashScreen';
import CreateOrder from './create-order/CreateOrder';
import CreateCdpOrder from './create-order/CreateCdpOrder';
import ProductDetail from './product-detail/ProductDetail';
import CdpProductDetail from './product-detail/CdpProductDetail';
import MainLayout from './layout/MainLayout';
import Header from './header/Header';
import { getEnvironment } from "../services/offpriceServices";
import NavPanel from './nav-panel/NavPanel';

export default class App extends React.Component {
  state = {
    cdpEnabled: true
  };
  componentDidMount() {
    this.getCdpEnableBool();
  }
  componentWillUnmount() {

  }
  getCdpEnableBool() {
    getEnvironment().then((res) => {
      if(res && res.data)
      window.$cdpEnabled = res.data.CDP_ENABLE;
      this.setState({ cdpEnabled: res.data.CDP_ENABLE });
    }, (r) => {
      alert('We are having problems trying to connect to the server. Please try again later.')
    });

  }
  render() {
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/loginsplash" component={LogInSplashScreen} />
          <Route exact path="/" component={HomeView} />
          <Route exact path="/logout" component={LogInSplashScreen} />
          <Route exact path="/home" component={HomeView} />
          <Route exact path="/search/:worksheetSearchText" component={HomeView} />
          <Route exact path="/create-order" component={CreateOrderView} />
          <Route exact path="/create-cdp-order" component={CreateCdpOrderView} />
          <Route exact path="/products/:worksheetId" component={ProductView} />
          <Route exact path="/cdp-products/:worksheetId" component={CdpProductView} />
        </Switch>
      </div>
    </Router>
  );
  }
};

function CreateOrderView() {
  return (
    <MainLayout
      header={(handleToggleSidepanel) =>
        <Header
          onToggleSidepanel={handleToggleSidepanel}
        />
      }
      sidePanel={(collapsed) => <NavPanel cdpEnabled={window.$cdpEnabled} collapsed={collapsed} />}
      content={() => <CreateOrder />}
    />
  )
}

function ProductView({ match }) {
  return (
    <MainLayout
      header={(handleToggleSidepanel) =>
        <Header
          onToggleSidepanel={handleToggleSidepanel}
        />
      }
      sidePanel={(collapsed) => <NavPanel cdpEnabled={window.$cdpEnabled} collapsed={collapsed} />}
      content={() => <ProductDetail worksheetId={match.params.worksheetId} />}
    />
  )
}


function CdpProductView({ match, location }) {
  let cdpObj = {};
  if(location.state) {
    cdpObj = location.state.cdpObj;
  } 
  return (
    <MainLayout
      header={(handleToggleSidepanel) =>
        <Header
          onToggleSidepanel={handleToggleSidepanel}
        />
      }
      sidePanel={(collapsed) => <NavPanel cdpEnabled={window.$cdpEnabled} collapsed={collapsed} />}
      content={() => <CdpProductDetail worksheetId={match.params.worksheetId} cdpObj={cdpObj} />}
    />
  )
}

function CreateCdpOrderView() {
  return (
    <MainLayout
      header={(handleToggleSidepanel) =>
        <Header
          onToggleSidepanel={handleToggleSidepanel}
        />
      }
      sidePanel={(collapsed) => <NavPanel cdpEnabled={window.$cdpEnabled} collapsed={collapsed} />}
      content={() => <CreateCdpOrder />}
    />
  )
}

function HomeView() {
  const params = new URLSearchParams(location.search)
  const searchText = params.get('search')
  return (
    <MainLayout
      header={(handleToggleSidepanel) =>
        <Header
          onToggleSidepanel={handleToggleSidepanel}
          worksheetSearchText={searchText}
        />
      }
      sidePanel={(collapsed) => <NavPanel cdpEnabled={window.$cdpEnabled} collapsed={collapsed} />}
      content={() => <Home worksheetSearchText={searchText} />}
    />
  )
}



// WEBPACK FOOTER //
// ./components/App.js